<template>
  <div class="visit-summary_letter">
    <span class="visit-summary_letter_title">
      {{ dearPatient }}
    </span>
    <v-card-text class="visit-summary_section-text visit-summary_letter_text">
      {{ encounterNotes.followUp }}
    </v-card-text>
    <div class="visit-summary_letter_title visit-summary_letter_initials">
      <span>{{ $t("visits.summary.assignedBy") }}</span>
      <img width="70" src="../../assets/practitioner-sign.svg" />
      <span>{{ practitionerName }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "VisitSummaryLetter",
  computed: {
    ...mapGetters("encounters", ["currentEncounter"]),
    ...mapGetters("visitNote", ["patientInfo", "encounterNotes"]),
    dearPatient() {
      return `${this.$t("visits.summary.dear")} ${this.patientInfo.firstName},`;
    },
    practitionerName() {
      if (!this.currentEncounter) return "";
      return `${this.$t("general.titles.dr")} ${this.currentEncounter.practitioner.name}`;
    },
  },
};
</script>
